import React from "react";
import Cube from "./Cube.jsx";
import { ProgressBar } from "react-bootstrap";
import styles from "./Skills.module.scss";

const ExperienceView = () => {
  return (
    <div className={styles.Skills} id="skills">
      <div className={styles.container}>
        <h2>Skills & Experience</h2>
        <p>
          This is summary of my skills from my point of view. It basically
          summarize
          <b>with what technologies I've spent most of my coding time.</b> HTML5
          and CSS3 are taken for granted. I've worked with technologies like
          Typescript, GraphQL and Git, Jira, Confluence stack.
        </p>

        <div className={styles.skill}>
          <span>React.js (Typescript)</span>
          <ProgressBar className={styles.progress} now={90} />
        </div>
        <div className={styles.skill}>
          <span>Node.js</span>
          <ProgressBar striped className={styles.progress} now={30} />
        </div>
        <div className={styles.skill}>
          <span>C++, OOP, Design patterns</span>
          <ProgressBar className={styles.progress} now={20} />
        </div>
        <div className={styles.skill}>
          <span>PHP</span>
          <ProgressBar striped className={styles.progress} now={10} />
        </div>
      </div>
      <div className={styles.cube}>
        <Cube />
      </div>
    </div>
  );
};
export default ExperienceView;
